import { isNil } from 'lodash';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

export function imageToCanvas(image: HTMLImageElement) {
  // transfer image to canvas
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  canvas.width = image.naturalWidth;
  canvas.height = image.naturalHeight;

  context.drawImage(image, 0, 0);

  return canvas;
}

// Convert an image src into a canvas
// This requires loading the image and handling the callback, so must be async
export function imageSrcToCanvas(src: string): Observable<HTMLCanvasElement> {
  return new Observable<HTMLCanvasElement>((observer) => {
    const image = new Image();
    image.onload = () => {
      const canvas = imageToCanvas(image);

      observer.next(canvas);
      observer.complete();
    };

    image.onerror = () => {
      // On error, create an empty canvas so we serve up a blank thumbnail
      const canvas = document.createElement('canvas');

      observer.next(canvas);
      observer.complete();
    };

    image.src = src;
  });
}

// Convert an image src into a blob
// This requires loading the image and handling the callback, so must be async
export function imageSrcToBlob(src: string): Observable<Blob> {
  return imageSrcToCanvas(src).pipe(
    filter((canvas) => !isNil(canvas)),
    switchMap((canvas) => {
      return new Observable<Blob>((observer) => {
        canvas.toBlob(
          (result) => {
            observer.next(result);
            observer.complete();
          },
          'image/jpeg',
          100,
        );
      });
    }),
  );
}
